import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Table, Form, Button, Alert } from 'react-bootstrap';
import api from '../../services/axios';

const TeleconnectAgents = (props) => {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [textToFind, setTextToFind] = useState('');
  const [onlyActive, setOnlyActive] = useState(true);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  const fetchAgents = async () => {
    setLoading(true);
    try {
      const response = await api.get('/teleconnect_accounts', {
        params: { textToFind, onlyActive: onlyActive ? "true" : "false", page, per_page: 20 }
      });
      const data = response.data.data || response.data || [];
      setAgents(Array.isArray(data) ? data : []);
      setLastPage(response.data.last_page || 1);
      setError(null);
    } catch (err) {
      setError('Error al cargar agentes');
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchAgents();
  }, [page]);

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    fetchAgents();
  };

  return (
    <Container className="mt-4">
      <h2>Agentes Teleconnect</h2>
      
      <Form onSubmit={handleSearch} className="mb-4">
        <Row>
          <Col md={4}>
            <Form.Control type="text" placeholder="Buscar cuenta, nombre, NIF..." value={textToFind} onChange={(e) => setTextToFind(e.target.value)} />
          </Col>
          <Col md={3}>
            <Form.Check type="checkbox" label="Solo activos" checked={onlyActive} onChange={(e) => setOnlyActive(e.target.checked)} />
          </Col>
          <Col md={2}>
            <Button type="submit" variant="primary">Buscar</Button>
          </Col>
        </Row>
      </Form>

      {loading ? (
        <p>Cargando...</p>
      ) : error ? (
        <Alert variant="danger">{error}</Alert>
      ) : (
        <>
          <Table striped bordered hover responsive size="sm">
            <thead className="bg-primary text-white">
              <tr>
                <th>Cuenta</th>
                <th>Nombre</th>
                <th>Comercial</th>
                <th>Estado</th>
                <th>Comisión</th>
                <th>Email</th>
                <th>Localidad</th>
              </tr>
            </thead>
            <tbody>
              {agents.map((agent) => (
                <tr key={agent.id}>
                  <td>{agent.cuenta}</td>
                  <td>{agent.nombreContacto} {agent.apellidosContacto}</td>
                  <td>{agent.reseller?.nombre || ''}</td>
                  <td style={{ color: agent.estado === 'ACTIVE' ? 'green' : 'red' }}>{agent.estado}</td>
                  <td>{agent.commission?.commission || ''}</td>
                  <td>{agent.email}</td>
                  <td>{agent.localidad}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          
          <div className="d-flex justify-content-center gap-2">
            <Button disabled={page <= 1} onClick={() => setPage(page - 1)}>Anterior</Button>
            <span className="align-self-center">Página {page} de {lastPage}</span>
            <Button disabled={page >= lastPage} onClick={() => setPage(page + 1)}>Siguiente</Button>
          </div>
        </>
      )}
    </Container>
  );
};

export default TeleconnectAgents;
